import PostLink from "components/boards/post/PostLink";
import CatchImage from "components/boards/post/catch/CatchImage";
import React, { Fragment } from "react";
import CatchInfo from "components/boards/post/catch/CatchInfo";
import PostHomePin from "../PostHomePin";
import HomePinSection from "../../../../pages/station/home/section/HomePinSection";
const CatchThumb = ({ vod, inflowPath, page, pageType, onDestroyPin, authority = {}, showCatchInfo = true, catchCreated = true, location='' }) => {
    // vod 정보 조회
    const { ucc = {}, is_vod_pin = false } = vod;
    return (
        <Fragment>
                <PostLink post={vod} inflowPaths={inflowPath} pageType={pageType} catchCreated={catchCreated} >
                     {/* 캐치 세로형 썸네일 노출 */}
                     <CatchImage vod={ucc} page={page}/>
                    {location !== 'home' && <PostHomePin post={vod} authority={authority} location={location} created={catchCreated} />}
                    {location === 'home' && is_vod_pin && <HomePinSection pinItem={vod} className='pin' onDestroyPin={onDestroyPin} boardTypeName={'VOD'} location={location} created={catchCreated} />}
                     {/* 캐치 정보 노출 */}
                     {page != "pc_vod" && (
                         <CatchInfo inflowPath={inflowPath} vod={vod} page={page} showCatchInfo={showCatchInfo}/>
                     )}
                </PostLink>
                {page === "pc_vod" && (
                    <CatchInfo inflowPath={inflowPath} vod={vod} page={page} pageTyp={pageType} showCatchInfo={showCatchInfo}/>
                )}
        </Fragment>
    );
};

export default CatchThumb;
